<template>
  <div class="adv-quantity-picker-container quick-v-quantity">
    <div class="d-flex justify-content-center align-items-center adv-quantity-picker-base">
      <span class="adv-quantity-picker-base-remove">
        <button
          :class="[
            buttonCssComputed,
            'adv-quantity-picker-base-remove-button btn pos-rel'
          ]"
          type="button"
          v-on:click="buttonRemove"
          :disabled="buttonRemoveDisabled"
          :aria-label="localQuantity <= min ? 'Minimum quantity reached' : 'Remove product'"
        >
            <slot name="minus"><i class="lni lni-minus"></i></slot>
        </button>
      </span>
      <input
        type="text"
        class="adv-quantity-picker-base-input form-control text-center product-quantity"
        aria-label="Products No"
        :disabled="true"
        v-model.number="localQuantity"
        v-on:change="checkQuantity"
      >
      <span class="adv-quantity-picker-base-add">
        <button
          :class="[
            buttonCssComputed,
            'adv-quantity-picker-base-add-button btn pos-rel'
          ]"
          type="button"
          v-on:click="buttonAdd"
          :disabled="buttonAddDisabled"
          :aria-label="localQuantity <= min ? 'Minimum quantity reached' : 'Remove product'"
        >
            <slot name="plus"><i class="lni lni-plus"></i></slot>
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import productMixin from './mixins/productMixins'

export default {
  name: 'AdvQuantityPickerBase',
  mixins: [productMixin],
  props: {
    buttonCss: {
      type: String
    },
    quantity: {
      type: Number,
      default: 0
    },
    productId: {
      type: Number,
      default: null
    },
    productCodeId: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localQuantity: this.quantity
    }
  },
  watch: {
    productCodeId () {
      this.localQuantity = this.productCodeData.productStock > 0 ? this.quantity : 0
    },
    quantity (val) {
      this.localQuantity = val
    }
  },
  computed: {
    min () {
      return this.productCodeData.productStock > 0 ? 1 : 0
    },
    max () {
      return this.productCodeData.productStock
    },
    buttonCssComputed () {
      return this.buttonCss
    },
    buttonRemoveDisabled () {
      return this.disabled
    },
    buttonAddDisabled () {
      if (this.disabled) {
        return true
      }
      return this.localQuantity >= this.max
    },
  },
  methods: {
    checkQuantity () {
      if (this.localQuantity < this.min) {
        this.localQuantity = this.min
      }

      if (this.localQuantity > this.max) {
        this.localQuantity = this.max
      }

      this.emitQuantity()
    },
    buttonRemove () {
      if (this.localQuantity === 1) {
        this.$emit('remove-from-cart')
        this.localQuantity = 0
        return
      }
      this.localQuantity -= 1
      this.checkQuantity()
    },
    buttonAdd () {
      this.localQuantity += 1
      this.checkQuantity()
    },
    emitQuantity () {
      this.$emit('quantity-changed', this.localQuantity)
    },
  }
}
</script>

<style lang="scss" scoped>
.adv-quantity-picker-base {
  min-height: 50px;
  .adv-quantity-picker-base-input {
    width: 100%;
    background-color: #EBEBF1;
  }
  .lni-minus {
    left: 25px
  }
  .lni-plus {
    right: 25px
  }
}
</style>
